import React from "react"
import styles from "./material-icon-view.module.scss"

export type MaterialIconSize = "small" | "normal" | "large" | "xlarge" | "xxlarge"

export interface MaterialIconProps {
  name: string
  size?: MaterialIconSize
  className?: string
  outlined?: boolean
}

const sizeClassMap: { [size in MaterialIconSize]: string } = {
  "small": styles.Small,
  "normal": styles.Normal,
  "large": styles.Large,
  "xlarge": styles.XLarge,
  "xxlarge": styles.XXLarge
}

export const MaterialIcon: React.FC<MaterialIconProps> = ({name, size = "normal", className, outlined}) => (
  <i className={`${outlined ? "material-icons-outlined" : "material-icons"} ${sizeClassMap[size]} ${className ?? ""}`}>
    {name}
  </i>
)

export default MaterialIcon
